export const formatDate = (date: Date): string => {
  const year = date.getFullYear()
  const day = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate()
  const realMonth = date.getMonth() + 1
  const month = realMonth < 10 ? `0${realMonth}` : realMonth

  return `${year}-${month}-${day}`
}

export const formatDateTime = (date: Date): string => {
  const year = date.getFullYear()
  const day = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate()
  const realMonth = date.getMonth() + 1
  const month = realMonth < 10 ? `0${realMonth}` : realMonth
  const hours = date.getHours() < 10 ? `0${date.getHours()}` : date.getHours()
  const minutes = date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes()
  const seconds = date.getSeconds() < 10 ? `0${date.getSeconds()}` : date.getSeconds()

  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`
}

export const convertDateTimeToUTC = (date: Date): string => {
  const utcDateTime = new Date(
    Date.UTC(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      date.getHours(),
      date.getMinutes(),
      date.getSeconds(),
    ),
  ).toUTCString()

  return utcDateTime
}

export const localizedDateTime = (date: Date, locale: string, UTC?: boolean) => {
  return new Intl.DateTimeFormat(locale, {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
    hourCycle: 'h23',
    timeZone: UTC ? 'UTC' : undefined,
  })
    .format(date)
    .replace(',', '')
}

export const localizedDate = (date: Date, locale: string, UTC?: boolean) => {
  return new Intl.DateTimeFormat(locale, {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    timeZone: UTC ? 'UTC' : undefined,
  }).format(date)
}

export const getCurrentUTCDateTime = (): string => {
  return new Date().toISOString().split('.')[0]
}
